/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SignRequest32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill={vars.bdlDarkBlue} d="M8 3h16a3 3 0 013 3v20a3 3 0 01-3 3H8a3 3 0 01-3-3V6a3 3 0 013-3z" />
            <path
                fill={vars.bdlDarkBlue50}
                d="M24 3c.982 0 1.854.472 2.401 1.201l-1.848 3.693A2 2 0 0122.763 9H9.334a2 2 0 01-1.846-1.23L5.871 3.885A2.99 2.99 0 018 3h16zm-8 3a1 1 0 100 2 1 1 0 000-2z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M20.688 22.375a.312.312 0 010 .625h-9.375a.312.312 0 010-.625h9.375zM14.75 13c1.21 0 1.995 1.415 1.873 2.865-.087 1.032-.799 2.266-1.794 3.292l-.069.07.049.076c.225.338.496.54.801.568l.078.004c.245 0 .456-.157.736-.555l.124-.184.219-.34.096-.141.089-.12c.26-.335.536-.535.923-.535.421 0 .711.244.917.614.048.086.087.167.127.264l.062.161.2.582.044.12.05.115.069-.018a1.43 1.43 0 00.498-.318l.091-.087a.625.625 0 01.884.884c-.525.525-1.091.808-1.692.808-.421 0-.711-.244-.917-.615a2.389 2.389 0 01-.127-.263l-.062-.161-.208-.604-.275.427c-.527.79-1.047 1.216-1.848 1.216-.783 0-1.394-.36-1.843-.974l-.057-.08-.035.028c-.573.421-1.188.756-1.803.955l-.153.047a.625.625 0 11-.344-1.202c.576-.164 1.167-.498 1.711-.922l.08-.065-.02-.062c-.224-.734-.338-1.605-.348-2.55v-.177c.005-1.75.657-3.123 1.874-3.123zm0 1.25c-.273 0-.621.733-.625 1.877a9.063 9.063 0 00.136 1.649l.023.122.103-.123c.525-.649.893-1.335.977-1.903l.013-.112c.069-.816-.316-1.51-.627-1.51zm3.125 1.875a.625.625 0 110 1.25.625.625 0 010-1.25z"
            />
        </g>
    </AccessibleSVG>
);

export default SignRequest32;
